import { AnyAction, combineReducers } from 'redux';
import { profileSlice } from './userProfile/userProfileSlice';
import { userSlice } from './user/userSlice';
import { eventSlice } from './event/eventSlice';
import { productSlice } from './product/productSlice';
import { roleSlice } from './role/roleSlice';
import { applicationSlice } from './application/applicationSlice';
import { applicationTypeSlice } from './applicationTypeOption/applicationTypeSlice';
import { configSlice } from './common/commonSlice';
import { adminLevelSlice } from './AdminLevel/AdminLevelSlice';
import { GroupManagementSlice } from './GroupManagement/GroupManagementSlice';
import { federalStateSlice } from './FederalState/FederalStateSlice';

const appReducer = combineReducers({
  userProfile: profileSlice.reducer,
  userDataSlice: userSlice.reducer,
  eventDataSlice: eventSlice.reducer,
  productDataSlice: productSlice.reducer,
  applicationDataSlice: applicationSlice.reducer,
  applicationTypeSliceData: applicationTypeSlice.reducer,
  roleSlice: roleSlice.reducer,
  configuration: configSlice.reducer,
  groupManagementSlice: GroupManagementSlice.reducer,
  [adminLevelSlice.name]: adminLevelSlice.reducer,
  [federalStateSlice.name]: federalStateSlice.reducer
});

export type RootState = ReturnType<typeof appReducer>;

const rootReducer = (state: RootState | undefined, action: AnyAction) => {
  return appReducer(state, action);
};

export default rootReducer;
